module.exports = __webpack_public_path__ + "static/appInto03-2edae82a287e9e9b30ab52c852da33e8.png";